// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fus_item--subtitle[data-v-33a0b3b1]{font-size:.8rem}", "",{"version":3,"sources":["webpack://./resources/client/modules/lead/components/FollowUpItem.vue"],"names":[],"mappings":"AAEA,qCACE,eADF","sourcesContent":["\n\n.fus_item--subtitle {\n  font-size: 0.8rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
